@if (avatar()?.smallUrl || avatar()?.bigUrl) {
  <img
    [ngSrc]="avatar()?.smallUrl || avatar()?.bigUrl"
    [alt]="firstName()"
    priority
    fill
  />
} @else {
  {{ firstLetter }}
}
